<template>
  <div>


<h2 class="goth">Prepositioner som styr ackusativ eller dativ</h2>


<div class="grammatikparagrafbredd leftorient">


<p>Efter följande prepositioner står substantivet eller pronomenet antingen i ackusativ <i>eller</i> i dativ.
    Huvudsakligen beroende på om prepositionen i sammanhanget uttrycker riktning eller befintlighet.</p>

<table class="">


    <tr class="leftorient">
        <td class="vit bgbrun"><b>an</b></td>
        <td class="vit bgbrun">på <div class="minitext">(vertikalt)</div>  <b> •|</b>, vid</td>
    </tr>

    <tr class="leftorient">
        <td class="vit bgbrun"><b>auf</b></td>
        <td class="vit bgbrun">på <div class="minitext">(horisontellt)     </div>
             &nbsp; <div style="display:inline-block;"><div style="transform: rotate(90deg);"><b>•|</b></div></div>  </td>
    </tr>

    <tr class="leftorient">
        <td class="vit bgbrun"><b>hinter</b></td>
        <td class="vit bgbrun">bakom</td>
    </tr>

    <tr class="leftorient">
        <td class="vit bgbrun"><b>in</b></td>
        <td class="vit bgbrun">i</td>
    </tr>

    <tr class="leftorient">
        <td class="vit bgbrun"><b>neben</b></td>
        <td class="vit bgbrun">bredvid, nära</td>
    </tr>

    <tr class="leftorient">
        <td class="vit bgbrun"><b>über</b></td>
        <td class="vit bgbrun">över, ovanför</td>
    </tr>

    <tr class="leftorient">
        <td class="vit bgbrun"><b>unter</b></td>
        <td class="vit bgbrun">under</td>
    </tr>

    <tr class="leftorient">
        <td class="vit bgbrun"><b>vor</b></td>
        <td class="vit bgbrun">framför</td>
    </tr>

    <tr class="leftorient">
        <td class="vit bgbrun"><b>zwischen</b></td>
        <td class="vit bgbrun">mellan</td>
    </tr>


</table>
<br>
<br>
<div class="quasi-p inlajn">Vid <div class="understryk-gron">riktning</div> används <div class="understryk-gron">ackusativ</div> (<b>RiA</b>)
    och vid <div class="understryk-rod">befintlighet</div> används <div class="understryk-rod">dativ</div> (<b>BeDa</b>) </div>

<br><br>
<div class="ruta">
<table class="mariginal-ner">

    <tr class="leftorient">
        <th class="gron">Riktning - ackusativ</th>
        <th class="rod">Befintlighet - dativ</th>
    </tr>

    <tr class="leftorient">
        <td><i>Ich hänge die Tafel <b class="gron">an die</b> Wand<br>Jag hänger tavlan på väggen</i></td>
        <td><i>Die Tafel hängt <b class="rod">an der</b> Wand<br>Tavlan hänger på väggen.</i></td>
    </tr>

    <tr class="leftorient">
        <td><i>Ich lege das Buch <b class="gron">auf den</b> Tisch<br>Jag lägger boken på bordet.</i></td>
        <td><i>Das Buch liegt <b class="rod">auf dem</b> Tisch<br>Boken ligger på bordet.</i></td>
    </tr>

    <tr class="leftorient">
        <td><i>Stell das Fahrrad <b class="gron">hinter das</b> Haus!<br>Ställ cykeln bakom huset!</i></td>
        <td><i>Das Fahrrad steht <b class="rod">hinter dem</b> Haus<br>Cykeln står bakom huset.</i></td>
    </tr>

    <tr class="leftorient">
        <td><i>Ich gehe <b class="gron">ins (in das)</b> Zimmer.<br>Jag går in i rummet.</i></td>
        <td><i>Du bist schon <b class="rod">im (in dem)</b> Zimmer.<br>Du är redan i rummet.</i></td>
    </tr>

    <tr class="leftorient">
        <td><i>Stell dich <b class="gron">neben mich</b>!<br>Ställ dig bredvid mig!</i></td>
        <td><i>Jetzt stehst du <b class="rod">neben mir</b>.<br>Nu står du bredvid mig.</i></td>
    </tr>

    <tr class="leftorient">
        <td><i>Wir hängen die Lampe <b class="gron">über den</b> Tisch.<br>Vi hänger lampan över bordet.</i></td>
        <td><i>Jetzt hängt die Lampe <b class="rod">über dem</b> Tisch.<br>Nu hänger lampan över bordet.</i></td>
    </tr>

    <tr class="leftorient">
        <td><i>Er geht <b class="gron">unter die </b> Brücke.<br>Han går <b>under</b> bron.</i></td>
        <td><i>Er geht <b class="rod">unter der</b> Brücke.<br>Han <b>går</b> under bron.</i></td>
    </tr>

    <tr class="leftorient">
        <td><i>Sie setzt sich <b class="gron">vor das </b> Haus.<br>Hon sätter sig framför huset.</i></td>
        <td><i>Er sitzt <b class="rod">vor dem</b> Haus.<br>Han sitter framför huset.</i></td>
    </tr>

    <tr class="leftorient">
        <td><i>Er stellt den Tisch <b class="gron">zwischen das</b> Sofa und <b class="gron">den </b> Fernseher.
            <br>Han ställer bordet mellan soffan och TV:n.</i></td>
        <td><i>Der Tisch steht <b class="rod">zwischen dem</b> Sofa und <b class="rod">dem </b> Fernseher.
            <br>Bordet står mellan soffan och TV:n.</i></td>
    </tr>




</table>

</div>




<br><br>





<h4 class="grammatikparagrafbredd leftorient">Bestämd artikel i ackusativ och dativ</h4><br>




<table class="">

    <tr class="leftorient">
        <td></td>
        <td class="ljusgra">mask.</td>
        <td class="ljusgra">neutr.</td>
        <td class="ljusgra">fem.</td>
        <td class="ljusgra">plur.</td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">nom.</td>
        <td class="vit bgbla">der</td>
        <td class="vit bgbla">das</td>
        <td class="vit bgbla">die</td>
        <td class="vit bgbla">die</td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">ack.</td>
        <td class="vit bggron"><b>den</b></td>
        <td class="vit bggron">das</td>
        <td class="vit bggron">die</td>
        <td class="vit bggron">die</td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">dat.</td>
        <td class="vit bgrod"><b>dem</b></td>
        <td class="vit bgrod"><b>dem</b></td>
        <td class="vit bgrod"><b>der</b></td>
        <td class="vit bgrod"><b>den ..n</b> </td>
    </tr>


</table>


<br><br>
<div class="quasi-p leftorient inramad">Oftast skrivs preposition och artikel ihop till ett ord i följande fall:<br>

    <nobr><i>an+das=<b>ans</b></i></nobr>
    &nbsp;&nbsp;<nobr><i>in+das=<b>ins</b></i></nobr>
    &nbsp;&nbsp;<nobr><i>an+dem=<b>am</b></i></nobr>
    &nbsp;&nbsp;<nobr><i>in+dem=<b>im</b></i></nobr></div>

<br><br>


<br>
    <h4 class="grammatikparagrafbredd leftorient">Obestämd artikel i ackusativ och dativ</h4><br>


    <table class="">

        <tr class="leftorient">
            <td></td>
            <td class="ljusgra">mask.</td>
            <td class="ljusgra">neutr.</td>
            <td class="ljusgra">fem.</td>

        </tr>

        <tr class="leftorient">
            <td class="ljusgra">nom.</td>
            <td class="vit bgbla">ein</td>
            <td class="vit bgbla">ein</td>
            <td class="vit bgbla">eine</td>
        </tr>

        <tr class="leftorient">
            <td class="ljusgra">ack.</td>
            <td class="vit bggron"><b>einen</b></td>
            <td class="vit bggron">ein</td>
            <td class="vit bggron">eine</td>
        </tr>
        <tr class="leftorient">
            <td class="ljusgra">dat.</td>
            <td class="vit bgrod"><b>einem</b></td>
            <td class="vit bgrod"><b>einem</b></td>
            <td class="vit bgrod"><b>einer</b></td>
        </tr>

    </table>

<br>


<br>
<h4 class="grammatikparagrafbredd leftorient">Personliga pronomen i ackusativ och dativ</h4><br>
<table class="">

    <tr class="leftorient">
        <td class="ljusgra">svenska</td>
        <td class="ljusgra">nominativ</td>
        <td class="ljusgra">ackusativ</td>
        <td class="ljusgra">dativ</td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">jag / mig</td>
        <td class="vit bgbla">ich</td>
        <td class="vit bggron"><b>mich</b></td>
                <td class="vit bgrod"><b>mir</b></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">du / dig</td>
        <td class="vit bgbla">du</td>
        <td class="vit bggron"><b>dich</b></td>
                <td class="vit bgrod"><b>dir</b></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">han / honom<br>det / det<br>hon / henne</td>
        <td class="vit bgbla">er<br>es<br>sie</td>
        <td class="vit bggron"><b>ihn</b><br>es<br>sie</td>
                <td class="vit bgrod"><b>ihm</b> <br> <b>ihm</b> <br> <b>ihr</b></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">vi / oss</td>
        <td class="vit bgbla">wir</td>
        <td class="vit bggron"><b>uns</b></td>
                <td class="vit bgrod"><b>uns</b></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">ni / er</td>
        <td class="vit bgbla">ihr</td>
        <td class="vit bggron"><b>euch</b></td>
                <td class="vit bgrod"><b>euch</b></td>
    </tr>

    <tr class="leftorient">
        <td class="ljusgra">de / dem<br>Ni / Er</td>
        <td class="vit bgbla">sie<br>Sie</td>
        <td class="vit bggron">sie<br>Sie</td>
                <td class="vit bgrod"><b>ihnen<br>Ihnen</b></td>
    </tr>

</table>

<br>

<p class="minitext">När ett ord står i ackusativ eller dativ efter något av prepositionerna
    <i>an, auf, hinter, in, neben, über, unter, vor,zwischen</i>
    kallas satsdelen <i><b>prepositionsobjekt i ackusativ </b>respektive<b> dativ</b></i>
    och skall inte förväxlas med <i>ackusativ- och dativobjekt</i></p>

</div>

</div>



</template>

<script>
export default {
  name: 'Grammatik',
  props: {
    msg: String
},

metaInfo() {
    return {
        meta: [
            {
                vmid: "description",
                name: "description",
                content: "prepositioner som styr ackusativ dativ"
            }
        ]
    }
},


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
